// CacheKey ed240762050436c1db3bf57b6d540ab6
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-ARCH_CARE": {
    simple_form: {
      labels: {
        defaults: {
          case_manager: "Care Manager",
          mrn: "Member ID",
          unit_id: "Team Number"
        },
        atlas_enrollment: {
          patient_id: "Member"
        },
        community_resource: {
          accepting_patients: "Accepting Members"
        },
        encounter: {
          alternate_provider_patient_id: "Alternate Member ID",
          case_manager: "Care Manager",
          diagnosis_related_group: "Primary DX Code",
          facility_mrn: "Facility Member ID",
          hospital_service: "Risk Level",
          mrn: "Member ID",
          patient_class: "Member Class",
          payor_status: "Plan ID",
          primary_discharge_diagnosis: "Primary DX Description",
          prior_patient_location: "Prior Member Location",
          provider_patient_id: "Member ID",
          secondary_discharge_diagnosis: "Secondary DX Description",
          tertiary_discharge_diagnosis: "Secondary DX Code",
          unit_id: "Team Number",
          unit_name: "Team Number"
        },
        floorplan: {
          unit_id: "Team Number",
          unit_name: "Team Number"
        },
        interaction: {
          current_unit: "Current Team Number"
        },
        issue: {
          current_unit: "Current Team Number"
        },
        patient: {
          health_plan_name: "Plan Name",
          mrn: "Member ID",
          multi_visit_patient: "Multi-Visit Member",
          patient_portal: "Member Portal",
          primary_policy_number: "Account Number",
          test_patient: "Test Member?"
        },
        unit: {
          name: "Team Number",
          unit_type: "Team Number Type"
        }
      },
      hints: {
        care_gram_email_template: {
          message: "Set message text for Care Gram email. Supported variables: [AuthorName], [AnswerText], [Recipients], [RoomNumber], [PatientInitials], [StaffMemberName], and [CareProviderName]. Confirm that including member initials in a notification is in compliance with the organization's security policies before adding [PatientInitials] to the email template message."
        },
        claim: {
          aid_category: "A field specifying the level of support required for the member.",
          days_count: "The number of days that the member was hospitalized or otherwise treated (ie number of visits made by a health care professional on an inpatient/outpatient basis)."
        },
        encounter_criterium: {
          action: "Whether to add or remove Member Tags or Rounding Flags when the criteria is met.",
          view_blueprint_ids: "Member will be enrolled in these Workflows.",
          view_blueprints_condition: "Members will not be re-enrolled into the workflow(s) if the encounter is updated and the above condition met again."
        },
        unit: {
          roundable: "Only encounters from \"Roundable\" units will be displayed in the Admitted Members lists (web and iOS) for rounding.",
          roundable_types: "(iOS) Used to determine units that should be available for filtering in unit rounding and units for member rounding."
        },
        view_blueprint: {
          link_blueprint_id: "When selected, enrolling members in View will also enroll them in Link."
        }
      },
      placeholders: {
        floorplan: {
          unit_id: "And select a team number…"
        }
      }
    }
  }
}

